import LogActions from '../Redux/LogRedux'
import packageJson from '../../../package.json'
import { config } from '../../Config/ConfigLoader'
import { WEB_TYPES_KEYS } from '../Redux/SettingsRedux.js'

const StackdriverMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  const state = getState()
  const { settings, gtm, quote } = state.appData
  const productName = config.getConfig('productName')
  if (
    action.type &&
    typeof settings.getIn(['activeSettings', 'stackDriver', productName], undefined) !== 'undefined' &&
    (settings.getIn(['activeSettings', 'stackDriver', productName, 'backOffice'], false) ===
      config.getConfig('isBackOffice') ||
      settings.getIn(['activeSettings', 'stackDriver', productName, 'client'], false) !==
        config.getConfig('isBackOffice'))
  ) {
    if (!settings.getIn(['activeSettings', 'stackDriver', productName, 'blacklist'], []).includes(action.type)) {
      const webType = settings.getIn(['webType'], 0)
      let logObj = {
        Resource: {
          Project: 'Suri20',
          Type: 'React',
          Application: {
            Name: 'Calculator',
            Version: packageJson.version,
          },
          Product: productName,
          Website: WEB_TYPES_KEYS[webType],
          Part: gtm.gtmPageView.page,
          Environment: DEV === true ? 'DEV' : 'Production',
          Server: '',
          Partner: webType === 4 ? 'REB' : 'PFP',
        },
        Action: {
          Type: action.type,
          First: '',
          Last: '',
        },
        Severity: '',
        Timestamp: new Date().toISOString(),
        Tracking: {
          Value: '',
          Duration: '',
          Statup: '',
        },
        Description: '',
        Tags: '',
      }

      if (action.type.includes('QUOTE_ASYNC_REQUEST_SUCCESS')) {
        logObj.Action.Id = action.asyncRequestId
        logObj.Action.SubType = quote.getIn(
          ['quoteRequests', action.quotesKey, 'quoteRequestData', 'enabledCalculators'],
          [],
        )
        dispatch(LogActions.sendLog(logObj))
      } else if (action.type.includes('SAVE_QUOTES')) {
        action.quotes.forEach((item) => {
          logObj.Tracking.Duration = (Date.now() - quote.getIn(['timeAsyncRequest', item.quoteRequest.id], 0)) / 1000
          logObj.Action.Id = item.quoteRequest.id
          logObj.Action.SubType = item.calculatorName
          logObj.Description = item.uniqueQuoteId
          dispatch(LogActions.sendLog(logObj))
        })
      } else if (action.type.includes('LOG_QUOTE_RECEIVED')) {
        const id = action.quote.quoteRequest.id
        logObj.Tracking.Duration = (Date.now() - quote.getIn(['timeAsyncRequest', id], 0)) / 1000
        logObj.Action.Id = id
        logObj.Action.SubType = action.quote.calculatorName
        logObj.Description = action.quote.id
        dispatch(LogActions.sendLog(logObj))
      }
    }
  }

  next(action)
}

export default StackdriverMiddleware
